export default class InvoicePaymentLinkResponse {
  id: string;

  amount: number;

  currency: string;

  paymentMethodId: string;

  paymentMethodType: string;

  paymentMethodFlow: string;

  country: string;

  createdDate: string;

  status: string;

  statusDetail: string;

  statusCode: string;

  orderId: string;

  originalOrderId: string;

  redirectUrl: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.amount = obj.amount || 0;
    this.currency = obj.currency || '';
    this.paymentMethodId = obj.paymentMethodId || '';
    this.paymentMethodType = obj.paymentMethodType || '';
    this.paymentMethodFlow = obj.paymentMethodFlow || '';
    this.country = obj.country || '';
    this.createdDate = obj.createdDate || '';
    this.status = obj.status || '';
    this.statusDetail = obj.statusDetail || '';
    this.statusCode = obj.statusCode || '';
    this.orderId = obj.orderId || '';
    this.originalOrderId = obj.originalOrderId || '';
    this.redirectUrl = obj.redirectUrl || '';
  }
}
